import {
  Inventory,
  LocationClosure,
  Notification,
  Tutorial,
  UserBasic,
  UserSettings,
  UserTermination,
} from '../_generated/openapi';
import { BasketballUser } from '../basketball/basketball-user';
import { ClubSettings, ClubSubscription } from './club';

export enum UserStatus {
  ACTIVE = 0,
  PASSIVE = 1,
  TERMINATED = 2,
}

export enum UserProgress {
  PENDING = 1,
  ACTIVE = 0,
}

export enum UserRole {
  BB_USER = 'bb_user',
  BB_REFEREE = 'bb_referee',
  BB_COACH = 'bb_coach',
  BB_ADMIN = 'bb_admin',
  VEHICLE_ADMIN = 'vehicle_admin',
}

export interface User {
  active_child_id?: number | null;
  avatar?: string | null;
  bank_account?: string | null;
  birthday?: string | null;
  city?: string | null;
  club_id: number;
  club_membernumber?: string | null;
  country?: string | null;
  created_at?: Date | null;
  email?: string | null;
  email_verified_at?: Date | null;
  firstname: string;
  handicap: string;
  id: number;
  /**  Defaults to: 0. */
  in_progress: UserProgress;
  lastname: string;
  nationality?: string | null;
  note?: string | null;
  password: string;
  pending?: boolean;
  phone?: string | null;
  position: string;
  remember_token?: string | null;
  represented_by?: string | null;
  sex?: number | null;
  /**  Defaults to: 0. */
  status: UserStatus;
  street?: string | null;
  updated_at?: Date | null;
  user_settings: UserSettings;
  zipcode?: string | null;
  basketball_user?: BasketballUser;
  role: string[];
  roles: UserRole[];
  // special fields
  club_settings: ClubSettings;
  club_subscription: ClubSubscription;
  initial_user_settings: boolean;
  notifications: {
    // TODO Notifications
    unread: Notification[];
    last5: Notification[];
  };
  unread: {
    tutorials: Tutorial[];
  };
  child_users: UserBasic[];
  active_child: User;
  custom_attribute_values?: UserCustomAttributeValue[];
  hasUnacceptedDPA: boolean;
  closed_locations?: LocationClosure[];
  open_tasks_count?: number;
  inventories?: Inventory[];
  active_termination?: UserTermination;
}

export interface UserCustomAttributeValue {
  id: number;
  user_id: number;
  attribute_id: number;
  value: any;
}

export enum UserCustomAttributeType {
  STRING = 0,
  NUMBER = 1,
  DATE = 2,
  MAIL = 3,
  SEX = 4,
  MULTI_MAIL = 5,
}
